import React from "react"

import {MDBNavBar} from "@meddbriefer/mdb-ui"

const UnauthedLayout = (props) => {

    return (
        <>
            <MDBNavBar
                title="MedDBriefer Authentication"
            />
            { props.children }
        </>
    )
}

export default UnauthedLayout